import { render } from "./WalletWithdraw.vue?vue&type=template&id=57b33a01"
import script from "./WalletWithdraw.vue?vue&type=script&lang=js"
export * from "./WalletWithdraw.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__